import { Orderable, Field } from '../../../domain';

export class SearchInput implements Orderable {
    constructor(
      public label: string,
      public order: number,
      public field: Field,
      public metadata?: boolean) {
    }
}

export class SearchInputs {
  constructor(
    public searchInputs: SearchInput[]) {
  }
}
